import React from "react";
import styled from "styled-components";
import { Button, CircularProgress } from "@mui/material";
import { ChevronLeft, ChevronRight } from "react-feather";

const Wrapper = styled.div`
  height: 46px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

const StyledButton = styled(Button)`
  height: 30px;
  width: 30px;
  display: flex;

  align-items: center;
  justify-content: center;
  min-width: 0px;
  background: #eeeeee90;
`;

const getPageData = (pageNumber, pageSize, totalRows) => {
  const start = pageNumber * pageSize - pageSize;
  const end = pageNumber * pageSize;

  return {
    start,
    end: end > totalRows ? totalRows : end,
  };
};

const CustomFooter = ({
  isLoading = false,
  totalPages = 1,
  setPage = () => {},
  page = 1,
  rowsPerPage,
  totalRows,
}) => {
  const { start, end } = getPageData(page, rowsPerPage, totalRows);

  return (
    <Wrapper>
      <div
        style={{
          marginRight: "auto",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginLeft: 6,
        }}
      >
        {!isLoading && (
          <span style={{ fontSize: 12, color: "darkgrey" }}>
            Showing submissions{" "}
            <b>
              {start + 1}-{end}
            </b>{" "}
            of <b>{totalRows}</b> total
          </span>
        )}
        {isLoading && (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <span style={{ fontSize: 12, color: "darkgrey" }}>
              Loading submissions...
            </span>
            <CircularProgress
              size={14}
              sx={{ color: "black", marginLeft: 12, marginRight: 6 }}
            />
          </div>
        )}
      </div>

      <div
        style={{
          display: "flex",
          alignItems: "center",
          padding: "0px 8px",
        }}
      >
        <StyledButton
          variant="text"
          color="inherit"
          disabled={page === 1 || isLoading}
          onClick={() => setPage((p) => p - 1)}
        >
          <ChevronLeft height={16} width={16} />
        </StyledButton>
        <div
          style={{
            width: 100,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <p style={{ color: "black", fontSize: 13 }}>
            Page <b style={{ color: "black" }}>{page}</b> of{" "}
            <b style={{ color: "black" }}>{totalPages}</b>
          </p>
        </div>
        <StyledButton
          variant="text"
          color="inherit"
          disabled={page === totalPages || isLoading}
          onClick={() => setPage((p) => p + 1)}
        >
          <ChevronRight height={16} width={16} />
        </StyledButton>
      </div>
    </Wrapper>
  );
};

export default CustomFooter;
